import { render, staticRenderFns } from "./no-access.component.vue?vue&type=template&id=4a8c207a"
var script = {}
import style0 from "./no-access.component.vue?vue&type=style&index=0&id=4a8c207a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports